import { css } from '@landr/styled-system/css';

export const contentStyles = css({
    alignItems: 'center',
});
